import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import GenericInputField from './GenericInputField'

const Wrapper = styled.div`
  flex: 0 1 35%;
  width: 45%;
  float: left;
  margin-left: 5%;

  @media (max-width: ${props => props.theme.responsive.large}) {
    width: 100%;
    margin-left: 0%;
  }
`

class RightSideContentView extends React.Component {
    render() {
        const {
            data,
            values,
            touched,
            errors,
            errorMessages,
            setFieldValue,
            setFieldTouched,
            siteMetadata,
            theme,
        } = this.props

        return (
            <Wrapper>
                {data.contentFields.map( (contentField, index) => {
                    return <GenericInputField
                        key={index}
                        typename={contentField.internal.type}
                        data={contentField}
                        values={values}
                        touched={touched}
                        errors={errors}
                        errorMessages={errorMessages}
                        setFieldValue={setFieldValue}
                        setFieldTouched={setFieldTouched}
                        siteMetadata={siteMetadata}
                        theme={theme}
                    />
                })}
            </Wrapper>
        )
    }
}

RightSideContentView.propTypes = {
    data: PropTypes.object,
    values: PropTypes.object,
    touched: PropTypes.object,
    errors: PropTypes.object,
    errorMessages: PropTypes.object,
    setFieldValue: PropTypes.func,
    setFieldTouched: PropTypes.func,
    siteMetadata: PropTypes.object,
    theme: PropTypes.object,
}

export default RightSideContentView
